import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";

import { dayFractionForTimestamp } from "../utils";

interface Props {
  dayColor?: string;
  nightColor?: string;
  rise: number;
  set: number;
  size?: string;
  always?: "up" | "down" | null;
  timezoneOffset?: number;
}

const halfTransitionTurnSize = 0.02;


export default /*@__PURE__*/_defineComponent({
  __name: 'DaylightPieChart',
  props: {
    dayColor: { default: "#ffdf22" },
    nightColor: { default: "#191970" },
    rise: {},
    set: {},
    size: { default: "100px" },
    always: { default: null },
    timezoneOffset: { default: 0 }
  },
  setup(__props: any) {

const props = __props;

const riseAngle = computed(() => dayFractionForTimestamp(props.rise + props.timezoneOffset));
const daylightFraction = computed(() => dayFractionForTimestamp(props.set - props.rise));

// Since noon is at the top, we need to shift everything for half a turn
function turnsForDayFraction(fraction: number): number {
  return (fraction + 0.5) % 1;
}

const cssVars = computed(() => {
  const dawnStart = `${turnsForDayFraction(riseAngle.value - halfTransitionTurnSize).toFixed(2)}turn`;
  const dawnEnd = `${turnsForDayFraction(riseAngle.value + halfTransitionTurnSize).toFixed(2)}turn`;
  const duskStart = `${turnsForDayFraction(riseAngle.value + daylightFraction.value - halfTransitionTurnSize).toFixed(2)}turn`;
  const duskEnd = `${turnsForDayFraction(riseAngle.value + daylightFraction.value + halfTransitionTurnSize).toFixed(2)}turn`;
  return {
    "--day-color": props.dayColor,
    "--night-color": props.nightColor,
    "--size": props.size,

    "--background":
        props.always == "up" ? props.dayColor :
          (props.always == "down" ? props.nightColor :
            `conic-gradient(
               var(--day-color) 0 ${duskStart},
               var(--night-color) ${duskEnd} ${dawnStart},
               var(--day-color) ${dawnEnd}
             )
             `),
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "daylight-pie-chart",
    style: _normalizeStyle(cssVars.value)
  }, null, 4))
}
}

})